document.addEventListener('DOMContentLoaded', function() {
  console.log("test");
  function updateCartTotal(cart) {
    const totalElement = document.querySelector('.saso-cart-original-total');
    if (totalElement) {
      totalElement.innerHTML = Shopify.formatMoney(cart.total_price, theme.moneyFormat);
    }
    
    // Update progress bar
    const progressBar = document.getElementById('progress-bar');
    const shippingInfo = document.querySelector('.shipping-info');
    const freeShippingThreshold = theme.freeShippingThreshold;
    const cartTotal = cart.total_price;
    
    let progress = (cartTotal / freeShippingThreshold) * 100;
    if (progress > 100) progress = 100;
    
    progressBar.style.width = progress + '%';
    
    if (cartTotal < freeShippingThreshold) {
      const amountNeeded = Shopify.formatMoney(freeShippingThreshold - cartTotal, theme.moneyFormat);
      shippingInfo.innerHTML = `You're ${amountNeeded} from <span>FREE SHIPPING</span>`;
    } else {
      shippingInfo.innerHTML = `Congratulations! You qualify for <span>FREE SHIPPING</span>`;
    }
  }

  function changeItemQuantity(variantId, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      updateCartTotal(cart);
    })
    .catch(error => console.error('Error:', error));
  }

  const minusButtons = document.querySelectorAll('.minus_btn');
  const plusButtons = document.querySelectorAll('.plus_btn');

  minusButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const input = this.nextElementSibling;
      let quantity = parseInt(input.value) - 1;
      if (quantity < 0) quantity = 0;
      input.value = quantity;
      changeItemQuantity(input.dataset.id, quantity);
    });
  });

  plusButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const input = this.previousElementSibling;
      let quantity = parseInt(input.value) + 1;
      input.value = quantity;
      changeItemQuantity(input.dataset.id, quantity);
    });
  });
});
// Rebuy Color Overrides
function fixRebuyStyles() {
  const fill = document.querySelector('.rebuy-cart__progress-bar-meter-fill');
  const track = document.querySelector('.rebuy-cart__progress-bar-meter');
  const bar = document.querySelector('[data-rebuy-component="announcement-bar"]');
  
  if (fill) fill.style.setProperty('background', '#ffc1d3', 'important');
  if (track) track.style.setProperty('background', '#ffe4ed', 'important');
  if (bar) {
    bar.style.setProperty('background-color', '#e8829a', 'important');
    bar.querySelectorAll('*').forEach(el => el.style.setProperty('color', '#fff', 'important'));
  }
}

document.addEventListener('rebuy:cart.open', fixRebuyStyles);
document.addEventListener('rebuy:cart.ready', fixRebuyStyles);

const rebuyObserver = new MutationObserver(() => { fixRebuyStyles(); fixCartFont(); });
rebuyObserver.observe(document.body, { childList: true, subtree: true });
// Cart title font
function fixCartFont() {
  const title = document.querySelector('.rebuy-cart__title');
  if (title) title.style.setProperty('font-family', 'NexaBlack, sans-serif', 'important');
}
document.addEventListener('rebuy:cart.open', fixCartFont);
rebuyObserver;